import { Component, OnDestroy } from '@angular/core';
import { IntlService } from '@progress/kendo-angular-intl';
import '@progress/kendo-angular-intl/locales/fr-CA/all';

import { TranslateService } from '@ngx-translate/core';
import { BusService } from './shared/services/bus.service';
import { BaseEntity } from './modules/shell/models/BaseEntity.model';
import { Subscription } from 'rxjs';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnDestroy{
 
  title = 'TinERP';
  menuLogoContainer = {'background-color': '#ededed'};
  icon = 'arrow_back_ios';

  private sub = new Subscription();

  public toggleIcon(): void {
      if (this.icon === 'arrow_back_ios') {
          this.icon = 'arrow_forward_ios';
          this.menuLogoContainer =  {'background-color': '#f8f7f7'};
      } else {
          this.icon = 'arrow_back_ios';
          this.menuLogoContainer =  {'background-color': '#ededed'};

      }
  }

  constructor(
    private serviceBus: BusService,
    private translate: TranslateService,
    public intlService: IntlService,
    ) {
      this.translate.addLangs(['en', 'fr']);
      this.translate.setDefaultLang(this.serviceBus.currentLanguage);
      this.translate.use(this.serviceBus.currentLanguage);
      BaseEntity.currentLanguage = this.serviceBus.currentLanguage;

       this.sub.add(window.addEventListener("beforeunload", (event: any) => {
        if (serviceBus.hasUnsavedChanges) {
          event.preventDefault();
          event.returnValue = "Unsaved modifications";
          return event;
        }
     }));

  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }
}
